import _ from 'lodash';
import { formatNumber } from './FormatNumberUtil';
import { SPECIAL_CHARACTER } from '../constants';

export const formatPrice = (price, unit = SPECIAL_CHARACTER.EURO) => {
  return !_.isUndefined(price) ? formatNumber(price) + ' ' + unit : SPECIAL_CHARACTER.EMPTY;
};
